import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { InventoryBoxQrsListItem } from "../../inventory.types";
import { requestGetInventoryBoxesQrsList } from "./getInventoryBoxesQrsList.request";

const useGetInventoryBoxesQrsList = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<InventoryBoxQrsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["inventory-box-admin", "all-qr", requestParams],
    queryFn: async () => await requestGetInventoryBoxesQrsList(requestParams),
    onError: toastServerError,
    ...options
  });

  return { inventoryBoxesQrsList: data?.data, meta: data?.meta, ...rest };
};

export default useGetInventoryBoxesQrsList;
